import { useState } from 'react';
import { withDashboardLayout } from 'layouts/DashboardLayout/DashboardLayout';
import { Card, Dimmer, Loader } from 'semantic-ui-react';
import PageContainer from 'components/PageContainer/PageContainer';
import Label from 'components/Label/Label';
import PrintLabelForm from 'components/PrintLabelForm/PrintLabelForm';
import Portal from 'components/Portal/Portal';

function SATPrinterPage() {
  const [isPrinting, setIsPrinting] = useState(false);

  return (
    <PageContainer title="Impresión SAT Reparaciones">
      <Dimmer active={isPrinting} inverted>
        <Loader>Imprimiendo…</Loader>
      </Dimmer>
      <Card.Header>
        <Label>Escanear e imprimir</Label>
        <Portal.Out name="card-header" />
      </Card.Header>
      <Card.Content>
        <PrintLabelForm isPrinting={isPrinting} setIsPrinting={setIsPrinting} />
      </Card.Content>
    </PageContainer>
  );
}

export default withDashboardLayout(SATPrinterPage);
